import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export default function PrintButton({ documentTitle }) {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  const handlePrint = () => {
    // Set document title for PDF filename
    const originalTitle = document.title;
    document.title = documentTitle || originalTitle;
    
    window.print();
    
    // Restore original title after print dialog
    setTimeout(() => {
      document.title = originalTitle;
    }, 100);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handlePrint}
      className="rounded-xl print:hidden"
      data-testid="print-pdf-button"
    >
      <Printer className="h-4 w-4 mr-2" />
      {isEnglish ? 'Download PDF' : 'Lataa PDF'}
    </Button>
  );
}
